/* @flow */

import _ from 'lodash'

import type {
  RootState,
  Action,
  ExpertOpinion,
  ExpertOpinionId,
  ExpertOpinionsStore,
} from '../types'
import { upsert, EmbedError, ActionRequiresPropertyError } from '../helpers'
import { selectIconById } from './iconsStore'

export const INTO_EXPERT_OPINIONS_STORE: string =
  'opinary/INTO_EXPERT_OPINIONS_STORE'

export function intoExpertOpinionsStore(items: Array<ExpertOpinion>): Action {
  return {
    type: INTO_EXPERT_OPINIONS_STORE,
    items,
  }
}

function embedAssociated(
  rootState: RootState,
  item: ExpertOpinion
): ExpertOpinion {
  const icon = selectIconById(rootState, item.iconId)
  if (icon == null) {
    throw new EmbedError(
      { name: 'expertOpinion', id: item.id },
      { name: 'icon', id: item.iconId }
    )
  }

  return Object.assign({}, item, {
    icon,
  })
}

export function selectExpertOpinion(
  rootState: RootState
): Array<ExpertOpinion> {
  return _(rootState.expertOpinionsStore)
    .values()
    .map(item => {
      return embedAssociated(rootState, item)
    })
    .value()
}

export function selectExpertOpinionById(
  rootState: RootState,
  id: ExpertOpinionId
): ?ExpertOpinion {
  const item = rootState.expertOpinionsStore[id.toString()]
  if (item == null) {
    return null
  }

  return embedAssociated(rootState, item)
}

export default function reducer(
  state: ExpertOpinionsStore = {},
  action: Action
): ExpertOpinionsStore {
  switch (action.type) {
    case INTO_EXPERT_OPINIONS_STORE:
      if (!action.items) {
        throw new ActionRequiresPropertyError(
          INTO_EXPERT_OPINIONS_STORE,
          'items'
        )
      } else {
        return upsert(state, action.items)
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/expertOpinionsStore.js